import { useTranslation } from "react-i18next";
function Msg() {
    const { t } = useTranslation();
    return (
            <div className="row justify-content-sm-center text-center py-10">
                <div className="col-sm-7 col-md-5" style={{ minWidth: "20rem" }}>
                    <img className="img-fluid mb-5" src="/assets/svg/illustrations/oc-thinking.svg" alt="Sin registros" />
                    <p>{t("empty-data")}</p>
                </div>
            </div>
    )
}

export default Msg